import React from 'react';
import { Box, Typography } from '@mui/material';

const DxfTab = () => {
  return (
    <Box
      sx={{
        width: '100%',
        minHeight: 400,
        border: '2px dashed #ccc',
        borderRadius: 2,
        backgroundColor: '#f5f5f5',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: 1,
        p: 2
      }}
    >
      <Typography variant="body2" color="text.secondary" align="center">
        🚧 Coming Soon 🚧
      </Typography>
      <Typography variant="caption" color="text.secondary" align="center">
        We're working on DXF support
      </Typography>
    </Box>
  );
};

export default DxfTab;
